class VariantMediaGallery {
  constructor() {
    this.productInfo = document.querySelector('product-info');

    if (!this.productInfo) return;

    this.gallery = this.productInfo.querySelector('media-gallery');

    if (!this.gallery) return;

    this.init();
  }

  init() {
    /*
     * IMPORTANT:
     * Do not immediately hide gallery images.
     * Dawn needs to finish its own variant/media update first.
     */
    this.productInfo.addEventListener('change', (event) => {
      if (
        event.target.matches(
          'input[type="radio"], select'
        )
      ) {
        this.waitForDawn();
      }
    });

    /*
     * Also watch for Dawn replacing/updating gallery markup.
     */
    this.observer = new MutationObserver(() => {
      clearTimeout(this.updateTimer);

      this.updateTimer = setTimeout(() => {
        this.filterVariantMedia();
      }, 150);
    });

    this.observer.observe(this.gallery, {
      childList: true,
      subtree: true
    });

    /*
     * Initial load
     */
    setTimeout(() => {
      this.filterVariantMedia();
    }, 500);
  }

  waitForDawn() {
    /*
     * Give Dawn time to update:
     * - selected variant
     * - featured media
     * - gallery position
     */
    setTimeout(() => {
      this.filterVariantMedia();
    }, 300);

    setTimeout(() => {
      this.filterVariantMedia();
    }, 700);
  }

  getSelectedOptions() {
    const options = [];

    /*
     * Radio variant options
     */
    this.productInfo
      .querySelectorAll(
        'input[type="radio"]:checked'
      )
      .forEach((input) => {
        if (input.value) {
          options.push(input.value.trim());
        }
      });

    /*
     * Select variant options
     */
    this.productInfo
      .querySelectorAll(
        'select[name^="options"]'
      )
      .forEach((select) => {
        if (select.value) {
          options.push(select.value.trim());
        }
      });

    return [...new Set(options)];
  }

  filterVariantMedia() {
    const selectedOptions = this.getSelectedOptions();

    if (!selectedOptions.length) return;

    const normalizedOptions =
      selectedOptions.map((value) =>
        this.normalize(value)
      );

    /*
     * ------------------------------------------
     * THUMBNAILS
     * ------------------------------------------
     *
     * We hide non-matching thumbnails.
     */
    const thumbnails =
      this.gallery.querySelectorAll(
        '.thumbnail-list__item[data-media-alt]'
      );

    let matchingThumbnailCount = 0;

    thumbnails.forEach((thumbnail) => {
      const alt = this.normalize(
        thumbnail.dataset.mediaAlt || ''
      );

      const matches =
        normalizedOptions.includes(alt);

      if (matches) {
        thumbnail.style.display = '';
        thumbnail.removeAttribute(
          'aria-hidden'
        );

        matchingThumbnailCount++;
      } else {
        thumbnail.style.display = 'none';
        thumbnail.setAttribute(
          'aria-hidden',
          'true'
        );
      }
    });

    /*
     * ------------------------------------------
     * MAIN MEDIA
     * ------------------------------------------
     *
     * IMPORTANT:
     * We do NOT hide the main images.
     *
     * Dawn controls the main image.
     *
     * This prevents the blank-image problem.
     */
    const mediaItems =
      this.gallery.querySelectorAll(
        '.product__media-item[data-media-alt]'
      );

    mediaItems.forEach((media) => {
      media.style.removeProperty('display');
      media.removeAttribute('aria-hidden');
    });

    /*
     * If no thumbnail matches, don't interfere
     * with Dawn's normal gallery behavior.
     */
    if (matchingThumbnailCount === 0) {
      thumbnails.forEach((thumbnail) => {
        thumbnail.style.removeProperty(
          'display'
        );

        thumbnail.removeAttribute(
          'aria-hidden'
        );
      });

      return;
    }
  }

  normalize(value) {
    return value
      .toLowerCase()
      .trim()
      .replace(/\s+/g, ' ');
  }
}

document.addEventListener(
  'DOMContentLoaded',
  () => {
    new VariantMediaGallery();
  }
);